import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { UsuarioLogin } from 'src/app/models/usuario-login.model';
import { UserLoginService } from 'src/app/services/user-login.service';
import { environment } from 'src/environments/environment';
import {Router} from "@angular/router";
import {CandidatoService} from "../../services/candidato.service";
import { UnespCoreMessageService, UnespCoreHomeModule } from "@unesp/core";
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatCardSubtitle, MatCardFooter } from '@angular/material/card';
import { FlexModule } from '@ngbracket/ngx-layout/flex';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    imports: [UnespCoreHomeModule, FlexModule, MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatIconButton, MatIcon, MatCardSubtitle, MatCardFooter, AsyncPipe]
})
export class HomeComponent implements OnInit, OnDestroy {
  private userSubscription!: Subscription;

  userLogin?: UsuarioLogin | null;

  infoCardVisibility: boolean = false;
  textoPerfis: string = '';


  private env = environment;
  candidatoInativo?: Observable<boolean>

  constructor(
    private userLoginService: UserLoginService,
    private router: Router,
    private candidatoService: CandidatoService
  ) { }

  ngOnInit(): void {
    this.userSubscription = this.userLoginService.user$.subscribe((user) => {
      this.userLogin = user;
      this.parseUser();
    });
    this.candidatoInativo = this.candidatoService.isCandidatoInativo()
    this.redirecionarConvite()

  }

  private parseUser() {
    if (this.userLogin) {
      if (this.userLogin.roles.length > 0) {
        Object.entries(this.env.roles).forEach(([key, value]) => {
          if (this.userLogin!.roles.includes(key)) {
            if (this.textoPerfis.length > 0) this.textoPerfis += ', ';
            this.textoPerfis += value.desc;
          }
        });
      }
    }
  }

  private redirecionarConvite() {
    if(localStorage.getItem("convite")){
      this.userLoginService.user$.subscribe({
        next: u => {
          if (u) {
            this.router.navigate(['candidatos', 'convite', localStorage.getItem("convite")])
          }
        }
      })
    }
  }

  toggleInfoCardVisibility() {
    this.infoCardVisibility = !this.infoCardVisibility;
  }

  get userLogin$(): Observable<UsuarioLogin | null> {
    return this.userLoginService.user$;
  }



  ngOnDestroy() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }


}
